<template>
<div v-if="email">
  <h1>{{ t('DADOS_CADASTRAIS') }}</h1>
  <div class="innerForm">
    <v-text-field placeholder="e-mail" :value="email" readonly style="cursor:none"></v-text-field>
    <v-app>
   <v-dialog @input="v => v || closePopup()" :fullscreen="isMobile()" v-model="dialog.open" max-width="600px">
      <template  v-slot:activator="{ on }">
         <a class="popupLink" v-if="hasPassword" appEventLabel="alterar senha" appEvent="true" appEventCategory="meus-dados" @click="openPopup">{{ t('ALTERAR_SENHA') }}</a>
      </template>
      <v-card>
        <v-card-title class="styled-header">
          <span >{{ t('ALTERAR_SENHA') }}</span>
          <span class="close" @click="closePopup" >X</span>
        </v-card-title>
        <v-card-text v-if="dialog.form">
          <v-form
          ref="form"
          v-model="valid"
        >
              <v-text-field 
              :placeholder="t('SENHA_ATUAL')" 
              color="#E46C0A "
              :type="show1 ? 'text' : 'password'"
              
               v-model="form.senhaAtual"
               :rules="rules.senhaAtual"
              required>
               <template v-slot:append>
                 <img v-if="!show1" width="24" src="../assets/img/olhovazado.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
               <v-text-field 
              :placeholder="t('NOVA_SENHA')" 
              color="#E46C0A "
              :type="show2 ? 'text' : 'password'"
               :rules="rules.novaSenha"
                v-model="form.novaSenha"
               @focus="messages=[]"
              required>
               <template v-slot:append>
               <img v-if="!show2" width="24" src="../assets/img/olhovazado.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
               <v-text-field
              color="#E46C0A "
              :placeholder="t('CONFIRMACAO_NOVA_SENHA')"
              :type="show3 ? 'text' : 'password'"
               :rules="rules.confirmaSenha"
               v-model="form.confirmaSenha"
               @focus="messages=[]"
              required>
               <template v-slot:append>
               <img v-if="!show3" width="24" src="../assets/img/olhovazado.svg" @click="show3 = !show3" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show3 = !show3" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              </v-form> 
              <ul v-if="messages.length" style="list-style: none; color: red; margin: 0; padding: 0"><li v-for="(message, key) in messages" :key="key">{{ message }}</li></ul>
               <a @click="submit() " appEvent="true" appEventCategory="alterar-senha" appEventLabel="confirmar" class="btn block">{{ t('CONFIRMAR') }}</a> 
        </v-card-text>
        <v-card-text v-else>
          <p>{{dialog.message}}</p>
            <a @click="closePopup" class="btn block">{{ t('FECHAR') }}</a> 
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
  </div>
</div>
<div v-else>
  <h1>{{ t('CADASTRO_USUARIO') }}</h1>
  <div class="innerForm">
    <v-text-field placeholder="e-mail" :value="email" readonly style="cursor:none"></v-text-field>
    <v-app>
   <v-dialog @input="v => v || closePopup()" v-model="dialog.open" max-width="600px">
      <template  v-slot:activator="{ on }">
         <a v-on="on" @click="dialog.form = true;">{{ t('ALTERAR_SENHA') }}</a>
      </template>
      <v-card>
        <v-card-title>
          <span >{{ t('ALTERAR_SENHA') }}</span>
        </v-card-title>
        <v-card-text v-if="dialog.form">
           <v-form
          ref="form-novo"
          v-model="valid"
        >
              <v-text-field 
              :placeholder="t('SENHA_ATUAL')" 
              color="#E46C0A "
              :type="show1 ? 'text' : 'password'"
              v-model="form.senhaAtual"
              :rules="rules.senhaAtual"
            
              required>
              <template v-slot:append>
 <img v-if="!show1" width="24" src="../assets/img/olhovazado.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              <v-text-field 
              :placeholder="t('NOVA_SENHA')" 
              color="#E46C0A "
               :rules="rules.novaSenha"
              :type="show2 ? 'text' : 'password'"
              
              v-model="form.novaSenha"
              required>
               <template v-slot:append>
                <img v-if="!show2" width="24" src="../assets/img/olhovazado.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
              <v-text-field
              color="#E46C0A "
              :rules="rules.confirmaSenha"
              :placeholder="t('CONFIRMACAO_NOVA_SENHA')"
              :type="show3 ? 'text' : 'password'"
                
              v-model="form.confirmaSenha"
              required>
              <template v-slot:append>
                <img v-if="!show3" width="24" src="../assets/img/olhovazado.svg" @click="show3 = !show3" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show3 = !show3" height="24" style="cursor:pointer"/>
              </template>
              </v-text-field>
               </v-form>
               <a @click="submit()" class="btn block">{{ t('CONFIRMAR') }}</a> 
        </v-card-text>
        <v-card-text v-else>
          <p>{{dialog.message}}</p>
            <a @click="closePopup" class="btn block">{{ t('FECHAR') }}</a> 
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
  </div>
</div>
</template>

<script>
import {VTextField,VDialog,VCard,VCardTitle,VCardText,VApp,VForm} from 'vuetify/lib'
import {resolvePromise,testaSenha,isMobile} from '../helpers/helpers'
import {updatePassword} from '../services/user.service'
import { translate } from '../services/translate.service';
export default {
  name: 'DadosCadastroForm',
  computed:{
    hasPassword(){
      return !this.socialId
    }
  },
  data(){
     return{
      dialog:{
        open:false,
        form:true,
        message:null
      },
      valid:false,
      show1:false,
      show2:false,
      show3:false,
      messages: [],
      rules:{
        senhaAtual:[()=> !!this.form.senhaAtual ||translate('VALIDATIONS.REQUIRED_FIELD'), 
                  () => testaSenha(this.form.senhaAtual && this.form.senhaAtual) || translate('VALIDATIONS.SENHA_RULES')],
        novaSenha:[()=> !!this.form.novaSenha || translate('VALIDATIONS.REQUIRED_FIELD'), 
                           () => testaSenha(this.form.novaSenha && this.form.novaSenha) || translate('VALIDATIONS.SENHA_RULES')],
        confirmaSenha:[()=> !!this.form.confirmaSenha || translate('VALIDATIONS.REQUIRED_FIELD'), 
                          () => (this.form.confirmaSenha === this.form.novaSenha) || translate('VALIDATIONS.CONFIRM_SENHA_INVALID')]
      },
      form:{
        senhaAtual:null,
        novaSenha:null,
        confirmaSenha:null
      }
    }
  },
  props: {
      email:{
        type:String,
      },
      socialId:{
        type:String
      }
  },
  methods:{
    t:translate,
    isMobile,
    closePopup(){
      if(this.$refs.form) this.$refs.form.reset()
      this.dialog.open = false
    },
    openPopup(){
        
        this.dialog.form = true
        this.dialog.open = true
    },
    submit(){
        this.messages = [];
          if(!this.$refs.form.validate()) return 
          const 
            formData = new FormData(),
            {senhaAtual,novaSenha} = this.form
          formData.append("CurrentPassword", senhaAtual);
          formData.append('NewPassword',novaSenha);
          resolvePromise(updatePassword(formData),(res) => {
            if(res.data && res.data.length) {
              this.messages = res.data.map(v => v.description);
            } else {
              this.dialog.form = false
              this.form = {
                  senhaAtual:{
                    valor:null,
                    msgErro:null
                  },
                  novaSenha:{
                    valor:null,
                    msgErro:null
                  },
                  confirmaSenha:{
                    valor:null,
                    msgErro:null
                  }
                }
              this.dialog.message = translate('SENHA_ALTERADA');
            }
          },()=>this.dialog.message = "erro, tente novamente",this)
    }
  },
  components:{
    VTextField,
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VApp,
    VForm
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/dadosCadastroForm.scss";
</style>
